import FormElments from '@/components/FormElements/'

export default {
  ...FormElments
}
